<template>
    <div class="verAddCon"  v-if='showModel' ref='verAddConRef' >
        <div class="mainTitle">{{title}}</div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />

      
                <div id="yellow" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side4')}}  0x04</h3>
                    <Button type="success" class="addButton" @click="addData(1,4,$t('BasicProduct.funcBox.sideList.side4')+' 0x04')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>
                    <!-- <Button type="info" class="addButton" @click="importData(1,4,$t('BasicProduct.funcBox.sideList.side4')+' 0x04')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.import")}}</Button> -->

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:4}" :hideOperate='true' :funType="$t('BasicProduct.funcBox.sideList.side4')+' 0x04'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>
                <div id="pink" class="scroll-item" style="min-height:300px;background-color:whrite;max-height:600px;overflow-y:scroll">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side5')}}  0x05</h3>
                    <Button type="success" class="addButton" @click="addData(1,5,$t('BasicProduct.funcBox.sideList.side3')+' 0x05')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>
                    <!-- <Button type="info" class="addButton" @click="importData(1,5,$t('BasicProduct.funcBox.sideList.side3')+' 0x05')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.import")}}</Button> -->

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:5}" :hideOperate='true' :funType="$t('BasicProduct.funcBox.sideList.side5')+' 0x05'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>
              
     
        <!-- 新增、编辑 -->
        <ModelBox :showSetModel.sync="addBox.showSetModel"  :type="type"  :basicTypeId='basicTypeId' :designImplTypeNum="addBox.designImplTypeNum"  :keyType="addBox.keyType" :funType='addBox.funType' :editFormData="addBox.editFormData" :fn="addBox.callbackFn"></ModelBox>
            
        <!-- 导入 -->
        <!-- <ImportBox :showModel.sync="importBox.showModel" :basicTypeId="basicTypeId"  :pageId="-1" :designImplTypeNum="addBox.designImplTypeNum" :isGener="importBox.isGener" :keyType="importBox.keyType" :funType='importBox.funType' :editFormData="importBox.editFormData"  :fn="importBox.callbackFn"></ImportBox> -->
        
    
    </div>

</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState,mapMutations } from 'vuex'
import TableTemp from "./table.vue"
import ModelBox from './setFuncModel.vue'
import ImportBox from './componentImport/importModel.vue'; // 引入导入弹框组件


    export default {
        props: {
            showModel: Boolean,
            fn:Function
        },
        name: "ModelFunc",
        components: {
            TableTemp,
            ModelBox,
            ImportBox
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                type:1,
                addBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    funType:'',
                    keyType:0,
                    designImplTypeNum:-1,//通用
                },
                importBox:{//规格弹框组-导入
                    showModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    funType:'',
                    keyType:0,
                    isGener:true,//是否可以删除，通用的功能和参数新增后不能删除，加了isGener=true， 修改只能改默认值，，没加可以删除
                },
                formData: {//表单数据
                   
                },
                basicTypeId:null,
                resData:{
                    loading:true,
                    result:[]
                }
               
            }
        },
        watch:{
            async showModel(val){
                if(val === true) {   
                    // await this.getWordList()
                    await this.getData()
                //    console.log('this.basicClassIdArr',this.editFormData)
                   
                }
            },
          
        },
        computed:{
             ...mapState(['local','selectId']),
             title(){
                let title = this.$t('BasicProduct.funcBox.title')
                return title
             }
        },
       async created(){
          
        },
        mounted(){
          
 
        },
       
        methods: {
            ...mapMutations(['setwordListByPageId','setWordList']),
            addData(type,keyType,funType,row={}){//新增
                this.addBox.showSetModel = true
                this.addBox.funType = funType
                this.addBox.keyType = keyType
                
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = row
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showSetModel = false;
                    this.addBox.funType = ''
                    this.addBox.keyType = 0
                    this.getData();
                }
            },
            async  getWordList(){
                this.resData.loading = true
                let params={
                        page:1,
                        limit:100000
                    }
                let  result = await this.axios.post(this.config.urlArray.pagesLangDictionaryList,params)
                if(result){
                    this.wordList = result.data.data.dealersList
                    this.setWordList(this.wordList)
                    
                }
                
            },
             importData(type,keyType,funType,row={}){//导入
                this.importBox.showModel = true
                this.importBox.showSetModel = true
                this.importBox.funType = funType
                this.importBox.keyType = keyType
               
                this.importBox.callbackFn = (successCount) => {//回调处理
                    //重新载入
                    // console.log('successCount',successCount)
                    this.importBox.showModel = false;
                    this.importBox.funType = ''
                    this.importBox.keyType = 0
                    if(successCount>0){
                        this.getData();
                    }
                }
            },
            setData(data){//、编辑数据
                this.addData(2,data.keyType, data.funType,data.row)
                // console.log('row',row)
            },
            todelData(data){//删除数据
               this.axios.post(this.config.urlArray.delBasicKeys,{id:data.id}).then(result=>{
                    common.ajaxMsg(result.data,true,()=>{
                    
                        this.getData();
                    })
               })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            },
            async getData(){ //获取通用功能、参数数据
                let params ={
                        basicTypeId:null,
                        dealerProductTypeId:null
                    }
                let  result = await this.axios.post(this.config.urlArray.getBasicKeys,params)
                if(result){
                    this.resData.result = result.data.data
                    this.resData.result.map((item,index)=>{
                        item.sortVal = index+1
                        return item
                    })
                    this.resData.loading = false
                }
            },
        }
    }
</script>

<style lang='less' scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    // overflow-y: scroll;
    overflow: auto;
    min-height: calc(100vh - 192px);
    .mainTitle{
        font-size: 20px;
        // position: fixed;
        // z-index: 99;
        background-color: #fff;
    }
    .colseButton{
        // position: absolute;
        // right: -18px;
        // top:-18px
        position: fixed;
        right: 37px;
        top: 127px;
    }
    .content{
        // margin-left: 240px;
        height: calc(100vh - 230px);
        // overflow-y: scroll;
        overflow: hidden;
    }
}
 /deep/ .ivu-form-item-content{
      margin-left: 176px !important;
  }
.logoCon{
  /deep/ .ivu-form-item-content{
      margin-left: 0px !important;
  }
}
 /deep/ .ivu-form .ivu-form-item-label{
    width: 162px !important;
}
.side{
    position: fixed;
    left: 302px;
    top:175px;
    /deep/ .ivu-menu-vertical.ivu-menu-light:after {
      background: #fff;
   }
}
</style>
